// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"114": "vidstack","768": "vendors-1","883": "vendors-0","945": "katex","954": "quill",}[chunkId] || chunkId) + "." + {"114": "e3aba1a5","138": "6080f4ea","182": "b546f888","326": "9071a24c","458": "5bfefca8","528": "2081b35b","540": "2438c005","768": "1587e760","880": "30a87d4d","883": "399733a2","945": "dfcf8e81","954": "eae65151",}[chunkId] + ".js"
}